import React from 'react'
import { Link } from 'react-router-dom'
import trackMkpEvents, { labels } from '../../lib/market-place-track-event'
import style from './index.module.scss'
export interface IBreadcrumb {
  title: string
  linkTo?: string | { pathname: string; search?: string }
}

export interface IBreadcrumbsProps {
  breadcrumbs: IBreadcrumb[]
}

const Breadcrumb: React.FunctionComponent<
  React.PropsWithChildren<IBreadcrumb & { position: number }>
> = ({ title, linkTo, position }) => {
  return linkTo ? (
    <li
      itemProp="itemListElement"
      itemScope
      itemType="https://schema.org/ListItem"
    >
      <Link
        className={style.breadcrumb}
        to={linkTo}
        onClick={() =>
          trackMkpEvents.clicked(labels.createCategoryBreadcrumb(title))
        }
        itemProp="item"
      >
        <span itemProp="name">{title}</span>
        <meta itemProp="position" content={String(position)} />
      </Link>
    </li>
  ) : (
    <li>
      <span className={style.breadcrumb}>{title}</span>
    </li>
  )
}

const Breadcrumbs: React.FunctionComponent<
  React.PropsWithChildren<IBreadcrumbsProps>
> = ({ breadcrumbs }) => {
  return (
    <nav aria-label="Breadcrumbs" className={style.breadcrumbs}>
      <ol itemScope itemType="https://schema.org/BreadcrumbList">
        {breadcrumbs.map((item, index) => {
          const key = `breadcrumb-${
            item.linkTo === undefined
              ? item.title
              : typeof item.linkTo === 'string'
              ? item.linkTo
              : item.linkTo.pathname + item.linkTo.search
          }`
          return (
            <Breadcrumb
              key={key}
              title={item.title}
              linkTo={item.linkTo}
              position={index + 1}
            />
          )
        })}
      </ol>
    </nav>
  )
}

export default Breadcrumbs
